import React from 'react';
import Particles from "react-particles-js"
import ParticlesConfig from './Config/ParticlesConfig';

const ParticleBackground = () => {
    return (
            <Particles 
                id="tsparticles"
                width='100vw'
                height='100vh'
                className='particles_style'
                params={ParticlesConfig}    
            />
    );
};

export default ParticleBackground;